








































import { Form, FormItem, Input, Button } from 'element-ui'
import { Component, Vue, Prop, Ref } from 'vue-property-decorator'

import ChangeDefaultPasswordForm from '@/models/change-default-password-form'

interface ErrorEntities {
  [field: string]: string[]
}

@Component({
  components: {
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Button.name]: Button,
  },
})
export default class UpdatePasswordForm extends Vue {
  @Prop() serverErrors!: ErrorEntities
  @Ref() readonly updatePasswordForm!: Form

  form: ChangeDefaultPasswordForm = {
    password: '',
    passwordConfirmation: '',
  }

  rules = {
    password: [
      { required: true, message: 'Password is required', trigger: 'blur' },
      {
        min: 8,
        message: 'Password should be at least 8 characters long',
        trigger: 'blur',
      },
    ],
    passwordConfirmation: [
      {
        validator: (
          rule: any,
          value: undefined,
          callback: (errors?: string) => void,
        ) => {
          if (this.form.password !== this.form.passwordConfirmation) {
            callback('Passwords should match')
          } else {
            callback()
          }
        },
        trigger: 'blur',
      },
    ],
  }

  get errors(): ErrorEntities {
    return this.serverErrors
  }

  submit(): void {
    this.updatePasswordForm.validate((isValid) => {
      if (isValid) {
        this.$emit('on-password-update', this.form)
      }
    })
  }
}
